import '@bnnvara/videojs-chromecast';
import '@bnnvara/videojs-chromecast/dist/videojs-chromecast.css';

export default {
  mapPropStateToOptions: props => ({
    appId: 'AED28AFD',
    metadata: {
      title: props.title,
      subtitle: props.description,
    },
  }),
};
